import { ConsumerPurchaseSummary, ConsumerPurchaseSummaryFragment } from 'generated/graphql';
import { LocalDateTime } from 'js-joda';
import { ReservationMetadataList } from 'components/business/reservation/ReservationMetadataList';
import { Typography } from 'omakase';
import { getIsAuthenticated } from 'selectors/appSelector';
import { useSelector } from 'react-redux';
import ReservationTitle from 'components/profile/ReservationTitle';

interface Props {
  reservation: ConsumerPurchaseSummaryFragment | ConsumerPurchaseSummary;
  title?: string;
  size: 'LARGE' | 'SMALL';
}

const ReservationDetails = ({
  title,
  reservation: { ticketType, ticketDateTime, ticketCount, ownerPatron, dinerPatron },
  size,
}: Props) => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const ticketTypeName = ticketType?.name;
  let reservationTime: LocalDateTime | undefined;

  if (ticketDateTime) {
    reservationTime = LocalDateTime.parse(ticketDateTime);
  }

  return (
    <>
      <div className="ReservationPreviewCard-headingSection">
        {title && <ReservationTitle title={title} />}
        <Typography
          variant="body02"
          mb={1}
          className="u-truncatedText"
          data-testid="experience-name"
        >
          {ticketTypeName}
        </Typography>
      </div>
      {reservationTime && (
        <div className="ReservationPreviewCard-detailsSection">
          <ReservationMetadataList
            showDateAndTime
            combineDateAndTime
            showQuantity
            showDinerAndOwner={
              !!(ownerPatron && dinerPatron && ownerPatron.email !== dinerPatron.email)
            }
            isShipping={!!ticketType?.reserveShippingTime}
            ticketTypeVariety={ticketType?.variety ?? undefined}
            ticketTypeDescriptiveVariety={ticketType?.descriptiveVariety ?? undefined}
            deliveryServiceProvider={ticketType?.deliveryServiceProvider ?? undefined}
            dateTime={reservationTime}
            showWeekday={false}
            purchaseCount={ticketCount}
            singleUnitQuantity={ticketType?.singleUnitQuantity ?? undefined}
            typographyVariant={size === 'LARGE' ? 'body02' : 'caption'}
            inVisitEdit={false}
            purchaseDiner={dinerPatron}
            purchaseOwner={ownerPatron}
            isAuthenticated={isAuthenticated}
          />
        </div>
      )}
    </>
  );
};

export default ReservationDetails;
